import PropTypes from "prop-types";
import { Button } from "../../components";
import { CheckboxInput } from "../../components";
import HintIconToolTip from "../../components/HintIconToolTip";

function InspectionStatus({ settings, onSettingChange, onSubmit, errors }) {
  const handleChangeCheckbox1 = (e) => {
    onSettingChange(e.target.name, e.target.checked);
  };

  const handleChangeCheckbox2 = (e) => {
    onSettingChange(e.target.name, e.target.checked);
  };

  return (
    <div
      className={`bg-white px-[30px] py-[15px] lg:px-[60px] lg:py-[30px] w-[640px] lg:w-[820px] lg:h-[420px] border border-tenken-gray-300 rounded-lg`}
      role="tabpanel"
    >
      <h4 className="text-tenken-tablet-heading-4 lg:text-tenken-heading-4 font-bold text-center">
        点検状況画面
      </h4>
      <h5 className="mt-2.5 lg:text-tenken-body font-light text-center">
        表の表示方法を選択してください。
      </h5>
      <div className="mt-[30px] lg:mt-[60px] flex border border-tenken-gray-250">
        <div className="bg-tenken-gray-070 w-[168px] lg:w-[240px] border-r border-tenken-gray-250 py-2 px-2 lg:py-4 lg:px-4">
          <div className="py-2 flex">
            <label>表示方法</label>
            <div className="lg:ml-2 ml-1 lg:mt-[2px]">
              <HintIconToolTip>
                <h4>■承認状況</h4>
                <p>承認状況列を表示します</p>
                <br />
                <h4>■月度承認</h4>
                <p>月度承認列を表示します</p>
              </HintIconToolTip>
            </div>
          </div>
        </div>
        <div className="py-2 px-3 lg:py-4 lg:px-6 flex items-center lg:w-[460px]">
          <div className="py-2">
            <div className="flex space-x-10">
              <CheckboxInput
                name="daily_approval_status"
                classInput="w-5 h-5"
                id="daily_approval_status"
                onChange={handleChangeCheckbox1}
                checked={settings.daily_approval_status ?? false}
                label="承認状況"
              />
              <CheckboxInput
                name="monthly_approval_status"
                classInput="w-5 h-5"
                id="monthly_approval_status"
                onChange={handleChangeCheckbox2}
                checked={settings.monthly_approval_status ?? false}
                label="月度承認"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-10 lg:mt-[80px] mb-[15px] lg:mb-[30px] flex justify-center">
        <Button
          color="yellow"
          className="min-w-[220px]"
          onClick={onSubmit}
          id="btn-setting-update"
        >
          更新
        </Button>
      </div>
    </div>
  );
}

InspectionStatus.propTypes = {
  settings: PropTypes.object,
};

export default InspectionStatus;
